// extracted by mini-css-extract-plugin
export default {"noAdvisoryContainer":"NoAdvisoryAvailable_noAdvisoryContainer__KxwgD","noAdvisoryBox":"NoAdvisoryAvailable_noAdvisoryBox__ZpBYW"};